<app-table
  #table
  rowIdKey="datatype_id"
  [title]="title"
  [columns]="columns"
  [data]="filteredData"
  [rowActions]="rowActions"
  (event)="onEvent($event)"
  [nbSpinner]="loading"
></app-table>
